import { config } from '../_config';
import {updateService as updateS} from './update.service';
import {updateService as updateFS} from './fake.update.service';
import { fakeLinkService as linksFS } from "./fake.links.serivce";
import { linkService as links } from "./links.service";
import { IUpdateService, ILinksService } from '../_types/interfaces';

export let updateService: IUpdateService;
export let linkService: ILinksService;

if (config.useFake === true) {
    updateService = updateFS;
    linkService = linksFS;
} else {
    updateService = updateS;
    linkService = links;
}